// extracted by mini-css-extract-plugin
module.exports = {"main":"option_main__1J5OZ"};